// extracted by mini-css-extract-plugin
export default {"comments-container":"styles_comments-container__pBeMp","comments-container-header":"styles_comments-container-header__+cxtI","add-comment-btn":"styles_add-comment-btn__X01HM"};